import { useState } from 'react'
import { useRestMutation } from '@shared/hooks/rest/mutate'
import { useMethods } from '@shared/hooks/methods'
import { useDialogs } from '@shared/hooks/dialogs'

import axios from '@shared/utils/axios'
import { useRestFetch } from '@shared/hooks/rest/fetch'

export const useList = () => {
    const [anchor, setAnchor] = useState(null)
    const [instance, setInstance] = useState(null)

    const {
        ask,
        showMessage
    } = useMethods()
    const { mutate } = useRestMutation({
        invalidate: [['users']],
        process: async () => (await axios.delete(`settings/users/${instance.id}/`)).data,
    })
    const { show } = useDialogs()
    const query = useRestFetch({ key: ['users'], endpoint: 'settings/users/' })

    // methods
    const handleDelete = () => {
        setAnchor(null)
        ask(
            `هل تريد حذف المستخدم '${instance.first_name}'`,
            mutate
        )
    }

    const handleFetchInstance = async () => {
        showMessage({
            text: 'جارٍ التحميل...',
            loading: true
        })
        try {
            const request = await axios.get(`settings/users/${instance.id}/`)
            showMessage(null)
            setAnchor(false)
            show('user', {instance: request.data})
        } catch (e) {
            showMessage({ text: 'حدث خطأ' })
        }
    }

    return {
        query,
        anchor,
        setAnchor,
        setInstance,

        handleDelete,
        handleFetchInstance
    }
}
